import { Button, Checkbox, Form, Input } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import styles from './style.module.css';

export const SIPAccountNetworkFields = () => (
  <div className={styles.panelContent}>
    <div className={styles.formGrid}>
      <Form.Item
        name="registrarHost"
        label="Адрес сервера регистрации"
        className={styles.fieldItem}
      >
        <Input placeholder="registrar.example.com" />
      </Form.Item>
      <Form.Item
        name="outboundProxy"
        label="Прокси-сервер"
        className={styles.fieldItem}
      >
        <Input placeholder="proxy.example.com" />
      </Form.Item>
    </div>
  </div>
);

export const SIPAccountIdentityFields = () => (
  <div className={styles.panelContent}>
    <div className={styles.formGrid}>
      <Form.Item
        name="displayName"
        label="Отображаемое имя пользователя"
        className={styles.fieldItem}
      >
        <Input placeholder="Название для SIP-идентификации" />
      </Form.Item>
      <Form.Item
        name="accountAor"
        label="Account AOR"
        className={styles.fieldItem}
      >
        <Input placeholder="sip:user@example.com" />
      </Form.Item>
      <Form.Item
        name="contactUri"
        label="Contact URI"
        className={styles.fieldItem}
      >
        <Input placeholder="sip:contact@example.com" />
      </Form.Item>
      <Form.Item
        name="sendUsernameInContact"
        valuePropName="checked"
        className={styles.defaultField}
        rules={[{ type: 'boolean' }]}
      >
        <Checkbox id="sendUsernameInContact">
          Отправлять имя пользователя в Contact
        </Checkbox>
      </Form.Item>
    </div>
  </div>
);

export const SIPAccountHeaderFields = () => (
  <div className={styles.panelContent}>
    <div className={styles.formGrid}>
      <Form.Item
        name="allowHeader"
        label="Allow-Header"
        className={styles.fieldItem}
      >
        <Input placeholder="INVITE, ACK, BYE" />
      </Form.Item>
    </div>
    <span className={styles.headersBlockTitle}>Ключ - Значение</span>
    <Form.List name="customHeaderRows">
      {(fields, { add, remove }) => (
        <div className={styles.headerEditor}>
          {fields.map(({ key, name, ...restField }, index) => (
            <div key={key} className={styles.headerRow}>
              <Form.Item
                {...restField}
                name={[name, 'key']}
                label="Ключ"
                className={styles.headerField}
              >
                <Input placeholder="X-custom-Header" />
              </Form.Item>
              <Form.Item
                {...restField}
                name={[name, 'value']}
                label="Значение"
                className={styles.headerField}
              >
                <Input placeholder="value" />
              </Form.Item>
              <Button
                type="text"
                danger
                icon={<DeleteOutlined />}
                className={styles.headerActionButton}
                aria-label={`Удалить SIP-заголовок ${index + 1}`}
                onClick={() => remove(name)}
              />
            </div>
          ))}
          <Button
            type="dashed"
            icon={<PlusOutlined />}
            className={styles.addHeaderButton}
            aria-label="Добавить SIP-заголовок"
            onClick={() => add({ key: '', value: '' })}
          >
            Добавить заголовок
          </Button>
        </div>
      )}
    </Form.List>
  </div>
);
